import "./ProgressBar.scss"
import styled from "styled-components"
import Coming from "./coming_soon.png"
export default ({widthRatio, isLast}) => {
    const Inner = () => <div style={{width: `${widthRatio}%`}} className="inner"/>
    return (
        <div className={"progress-bar"}>
            {isLast && <ComingSoon src={Coming}/>}
            <Inner/>
        </div>
    )
}

const ComingSoon = styled.img`
position: absolute;
right: 0;
bottom: 18px;
width: 148px;
`